export enum PerfilMantisEnum {
    INFORMADOR = 'MantisInformador',
    DESARROLLADOR = 'MantisDesarrollador',
    ASOFONDOS = 'MantisAsofondos',
}
